/**
 * Wraps a field control that would otherwise let the value be edited, keeping
 * it visually present but permanently locked:
 *  - `inert` on the children's wrapper removes the whole subtree from the tab
 *    order and blocks focus/keyboard interaction natively (the same guarantee
 *    a native `<fieldset disabled>` gave us) — without it, a keyboard user
 *    could Tab past the overlay straight into a VendorField/LineItemsTable
 *    input and edit it.
 *  - a transparent overlay on top intercepts the mouse click (an inert or
 *    disabled control never dispatches a click at all, so a plain onClick on
 *    an ancestor can't catch it), keeping the control fully read-only.
 * Shared by the NetSuite and Business Central request views.
 *
 * `isEditMode` controls the gate: true (default) passes children through
 * untouched; false locks the subtree and routes clicks to `onBlockedClick`
 * instead of the wrapped control.
 */
export default function EditGate({ children, isEditMode = true, onBlockedClick }) {
  if (isEditMode) return children

  return (
    <div className="relative">
      <div inert="">{children}</div>
      <div
        className="absolute inset-0 z-10 cursor-not-allowed"
        title='Click "Edit" to modify fields'
        onClick={onBlockedClick}
      />
    </div>
  )
}
